<template>
  <div class="social-item p-4">
    <div class="content">
      <div class="icon-social">
        <i :class="['icon', social_data.icon]" />
      </div>
      <div class="description">
        <div class="name">{{social_data.name}}</div>
        <div class="text-left">{{social_data.text}}</div>
      </div>  
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocialItem',
  props: ['social_data']
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

